<template>
  <div>
    <template v-if="state === ''">
      <transactions-list />
    </template>
    <template v-else-if="state === 'loading'">
      <div class="d-f f-1 ai-c jc-c">
        <div class="loading-spinner large"></div>
      </div>
    </template>
  </div>
</template>

<script>

import TransactionsList from '@/components/Commerce/TransactionsList.vue';

export default {
  components: {
    TransactionsList,
  },
  methods: {
    /**
     * Get the transactions based on params from state
     * @returns {Void}
     */
    async getTransactions() {
      const { transactions, pagination, total } = await this.$store.dispatch('Transactions/getTransactions', {
        page: this.current_page,
        sort: this.sort,
        direction: this.direction,
        per_page: this.per_page,
        skipConf: true,
        skipState: true,
      });

      this.transactions = transactions;
      this.max_page = pagination.max_page;
      this.current_page = pagination.current_page;
      this.total_transactions = total;
    },
    /**
     * Paginate in video list
     * @param {Number} page
     * @returns {Void}
     */
    paginate(page) {
      this.current_page = page;

      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page,
        },
      });

      this.getTransactions();
    },
  },
  data() {
    return {
      state: 'loading',
      transactions: [],
      current_page: 1,
      max_page: 1,
      per_page: 20,
      total_transactions: 0,
    };
  },
  async mounted() {
    const {
      page = 1,
      sort = 'created',
      direction = 'desc',
    } = this.$queryHelper.get({ validSort: ['created', 'id'] });

    this.current_page = page;
    this.sort = sort;
    this.direction = direction;

    // await this.$store.dispatch('Products/getAllStreams');
    // await this.getTransactions();

    this.state = '';
  },
};
</script>
